import React, { useEffect, useState } from "react";
import {
  Typography,
  FormLabel,
  TextField,
  Button,
  Box,
  Grid,
} from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";
import plusIcon from "../img/PlusIcon.svg";

const AspectosMejorar = () => {
  const { promptData, setPromptData } = useActividadesContext();
  const [agregarAspecto, setAgregarAspecto] = useState(false);
  const [nuevoAspecto, setNuevoAspecto] = useState("");
  const [aspectosClave, setAspectosClave] = useState(promptData.mejoras || []);
  const { setProyecto } = useProyecto();

  useEffect(() => {
    setAspectosClave(promptData.mejoras || []);
  }, [promptData]);

  const handleGuardarAspecto = () => {
    if (nuevoAspecto.trim() !== "") {
      const nuevosAspectos = [...aspectosClave, nuevoAspecto];
      setAspectosClave(nuevosAspectos);
      setNuevoAspecto("");
      setAgregarAspecto(false);
      setPromptData((prevData) => ({
        ...prevData,
        mejoras: nuevosAspectos,
      }));
    }
  };

  const handleAgregarAspecto = () => {
    setAgregarAspecto(true);
  };

  const handleEliminarAspecto = (index) => {
    // Obtiene el aspecto clave a eliminar
    const aspectoAEliminar = aspectosClave[index];
    const nuevosAspectos = aspectosClave.filter((_, i) => i !== index);
    // Actualiza el estado de los aspectos clave, eliminando el aspecto clave seleccionado
    setAspectosClave(nuevosAspectos);
    setPromptData((prevData) => ({
      ...prevData,
      mejoras: nuevosAspectos,
    }));
    // Actualiza el estado del proyecto, eliminando el aspecto clave seleccionado
    setProyecto((prevProyecto) => ({
      ...prevProyecto,
      aspectos_mejorar_clave: prevProyecto.aspectos_mejorar_clave
        ? prevProyecto.aspectos_mejorar_clave.filter(
            (aspecto) => aspecto !== aspectoAEliminar
          )
        : [],
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={3}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          Aspectos a Mejorar
        </Typography>
      </Box>
      <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
        Menciona los aspectos en los que el estudiante puede mejorar. Ejemplo:
        Fortalecimiento de la lectura y puntualidad
      </FormLabel>
      {agregarAspecto ? (
        <Grid container spacing={2} mt={3} alignItems="center">
          <Grid item xs={12} sm={8}>
            <TextField
              label="Nuevo Aspecto"
              variant="outlined"
              fullWidth
              value={nuevoAspecto}
              onChange={(e) => setNuevoAspecto(e.target.value)}
              sx={{ fontFamily: "montserrat", mr: 2, mb: 2 }}
              InputProps={{
                sx: {
                  borderRadius: 2,
                  fontFamily: "montserrat",
                  fontSize: "0.75rem",
                  color: "#336B87",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              sx={{
                backgroundColor: "#336B87",
                "&:hover": { backgroundColor: "#2B7C83" },
                fontFamily: "montserrat",
                fontWeight: "bold",
              }}
              variant="contained"
              onClick={handleGuardarAspecto}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 3,
            flexWrap: "wrap",
          }}
        >
          {aspectosClave.map((aspecto, index) => (
            <Box key={index} sx={{ display: "inline-block", m: 1 }}>
              <Button
                variant="outlined"
                onClick={() => handleEliminarAspecto(index)}
                sx={{
                  color: "#336B87",
                  fontFamily: "Montserrat",
                  fontWeight: "medium",
                  fontSize: "1.25rem",
                  borderColor: "rgba(51, 107, 135, 0.3)",
                  borderRadius: 50,
                  backgroundColor: "rgba(51, 107, 135, 0.3)",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#FFF",
                    borderColor: "#336B87",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    color: "#336B87",
                    textTransform: "none",
                  }}
                >
                  {aspecto}
                  <HighlightOffIcon sx={{ ml: 1, color: "#CD5C5C" }} />
                </Typography>
              </Button>
            </Box>
          ))}
          <Button
            variant="outlined"
            sx={{
              fontFamily: "Montserrat",
              fontWeight: "medium",
              fontSize: "1.25rem",
              borderColor: "rgba(51, 107, 135, 0.3)",
              borderStyle: "dashed",
              borderRadius: 50,
              backgroundColor: "#FFF",
              boxShadow: 3,
              "&:hover": {
                backgroundColor: "rgba(51, 107, 135, 0.3)",
                boxShadow: 6,
                borderColor: "rgba(51, 107, 135, 0.3)",
                borderStyle: "dashed",
              },
              color: "#336B87",
              textTransform: "none",
            }}
            onClick={handleAgregarAspecto}
          >
            <img
              src={plusIcon}
              alt="Icono"
              style={{ width: "25px", height: "25px" }}
            />
          </Button>
        </Box>
      )}
    </Grid>
  );
};

export default AspectosMejorar;
